import { render, staticRenderFns } from "./ChatEmojisDropdown.vue?vue&type=template&id=faf3cba8&scoped=true"
import script from "./ChatEmojisDropdown.vue?vue&type=script&lang=js"
export * from "./ChatEmojisDropdown.vue?vue&type=script&lang=js"
import style0 from "./ChatEmojisDropdown.vue?vue&type=style&index=0&id=faf3cba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf3cba8",
  null
  
)

export default component.exports